<script setup>
defineProps({
    title: {
        type: String,
        default: '',
    },
})
</script>

<template>
    <div class="base-content">
        <div
            v-if="title"
            class="main-heading"
        >{{ title }}</div>
        <slot />
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.base-content {
    position: relative;
    z-index: $layer-page-z-index;
}

.main-heading {
    @include title;

    margin-top: $s-s;
    margin-bottom: $s-xxl;

    @include desktop {
        @include container;

        margin-bottom: $s-xxl;
    }

    @include sidePadding;
}
</style>
